import Checkbox from '@/modules/drivers/shared/Checkbox'

import * as React from 'react'

interface Props {
  children?: React.ReactNode
  label: string
  field?: string
  data?: any
  setData?: any
  defaultChecked?: boolean
  onChange?: (checked: boolean) => void
  disabled?: boolean
  value?: boolean
  id?: string
  background?: boolean
  noPadding?: boolean
}

const CheckboxWithLabelField = ({
  children,
  label,
  field,
  data,
  setData,
  onChange,
  disabled,
  value,
  noPadding = false,
  defaultChecked = false,
  background = true,
  id = 'checkbox-' + Math.random().toString(36),
}: Props) => {
  React.useEffect(() => {
    if (defaultChecked && field && data?.[field] === undefined && setData) {
      setData({ ...data, [field]: true })
    }
  }, [])

  const fieldValue = field ? data?.[field] : undefined
  const checked =
    value !== undefined
      ? value
      : fieldValue !== undefined
        ? fieldValue
        : defaultChecked
  return (
    <div
      className={`tw-my-1 tw-flex tw-cursor-pointer tw-flex-col tw-items-start tw-gap-2 tw-rounded ${noPadding ? 'tw-p-0' : 'tw-p-4'} ${background ? 'tw-bg-[#f2f2f2]/50' : ''} ${disabled ? 'tw-opacity-50' : ''}`}
    >
      <label
        htmlFor={id}
        className="tw-m-0 tw-flex tw-cursor-pointer tw-items-center tw-gap-2"
      >
        <div className="tw-flex tw-items-center tw-gap-2">
          <Checkbox
            id={id}
            disabled={disabled}
            checked={value !== undefined ? value : checked}
            onChange={(e) =>
              onChange ? onChange(e) : setData?.({ ...data, [field]: e })
            }
          />
        </div>
        <p className="tw-text-sm">{label}</p>
      </label>

      {children && (
        <div
          className={`tw-w-full tw-transition-all tw-duration-200 ${
            !checked
              ? 'tw-hidden tw-max-h-0 tw-overflow-hidden tw-opacity-0'
              : 'tw-max-h-fit tw-pt-2 tw-opacity-100'
          }`}
        >
          {children}
        </div>
      )}
    </div>
  )
}

export default CheckboxWithLabelField
